import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import API from 'config/ApiConfig';

export default function CreateTentorForm({ onSubmit }) {
  const [formData, setFormData] = useState({
    nama: '',
    email: '',
    alamat: '',
    telepon: '',
    ngaji: '',
    kemampuan: '',
    pendidikan: '',
    pengalaman: '',
    ketersediaan: [],
    user_id: ''  // Menyimpan user_id yang dipilih
  });

  const [errors, setErrors] = useState({});
  const [users, setUsers] = useState([]);
  const [fetchError, setFetchError] = useState(null);

  // const API_BASE_URL = 'http://localhost:5000/api/admin';
  const API_BASE_URL = API.API_ADMIN
  const JWT_TOKEN = localStorage.getItem('authToken');

  function getAuthHeaders() {
    return {
      'Authorization': `Bearer ${JWT_TOKEN}`,
      'Content-Type': 'application/json',
    };
  }

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/user`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error('Error fetching users:', error);
        setFetchError('Failed to fetch users.');
      }
    };
    fetchUsers();
  }, []);

  const validate = () => {
    const errors = {};
    if (!formData.user_id) errors.user_id = 'User is required';
    if (!formData.nama) errors.nama = 'Nama is required';
    if (!formData.email) errors.email = 'Email is required';
    if (!formData.telepon) errors.telepon = 'Telepon is required';
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validate()) {
      const dataToSubmit = {
        ...formData,
        kemampuan: formData.kemampuan.split(',').map(item => item.trim()).filter(item => item !== '')
      };

      try {
        const response = await fetch(`${API_BASE_URL}/tentor`, {
          method: 'POST',
          headers: getAuthHeaders(),
          body: JSON.stringify(dataToSubmit),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Tentor created:', data);

        // Reset form and errors on successful submit
        setFormData({
          nama: '',
          email: '',
          alamat: '',
          telepon: '',
          ngaji: '',
          kemampuan: '',
          pendidikan: '',
          pengalaman: '',
          ketersediaan: [],
          user_id: ''
        });
        setErrors({});
        if (onSubmit) onSubmit(data); // Optional: Callback on success
      } catch (error) {
        console.error('Error creating tentor:', error);
      }
    }
  };

  const handleKetersediaanChange = (event, index) => {
    const { name, value } = event.target;
    const newKetersediaan = [...formData.ketersediaan];
    newKetersediaan[index] = { ...newKetersediaan[index], [name]: value };
    setFormData(prevState => ({
      ...prevState,
      ketersediaan: newKetersediaan
    }));
  };
  const handleClickCreate = () => {
    alert('Berhasil Membuat User');
    window.location.href = '/admin/tentor';
  };

  const addKetersediaanField = () => {
    setFormData(prevState => ({
      ...prevState,
      ketersediaan: [...prevState.ketersediaan, { hari: '', waktu_mulai: '', waktu_selesai: '' }]
    }));
  };

  const removeKetersediaanField = (index) => {
    setFormData(prevState => ({
      ...prevState,
      ketersediaan: prevState.ketersediaan.filter((_, i) => i !== index)
    }));
  };

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Tambah Tentor</h3>
      {fetchError && <p className="text-red-500 text-xs">{fetchError}</p>}
      <form onSubmit={handleSubmit} className="space-y-2">
        {/* Dropdown untuk memilih user */}
        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-user"></i>
          </span>
          <select
            name="user_id"
            value={formData.user_id}
            onChange={(e) => setFormData({ ...formData, user_id: e.target.value })}
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          >
            <option value="">Pilih User</option>
            {users.map(user => (
              <option key={user._id} value={user._id}>
                {user.username}
              </option>
            ))}
          </select>
          {errors.user_id && <p className="text-red-500 text-xs">{errors.user_id}</p>}
        </div>

        {/* Input fields for tentor details */}
        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-user"></i>
          </span>
          <input
            type="text"
            name="nama"
            value={formData.nama}
            onChange={(e) => setFormData({ ...formData, nama: e.target.value })}
            placeholder="Nama"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
          {errors.nama && <p className="text-red-500 text-xs">{errors.nama}</p>}
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-envelope"></i>
          </span>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            placeholder="Email"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
          {errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-home"></i>
          </span>
          <input
            type="text"
            name="alamat"
            value={formData.alamat}
            onChange={(e) => setFormData({ ...formData, alamat: e.target.value })}
            placeholder="Alamat"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
          {errors.alamat && <p className="text-red-500 text-xs">{errors.alamat}</p>}
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-phone"></i>
          </span>
          <input
            type="text"
            name="telepon"
            value={formData.telepon}
            onChange={(e) => setFormData({ ...formData, telepon: e.target.value })}
            placeholder="Nomor Telepon"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
          {errors.telepon && <p className="text-red-500 text-xs">{errors.telepon}</p>}
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-book"></i>
          </span>
          <input
            type="text"
            name="ngaji"
            value={formData.ngaji}
            onChange={(e) => setFormData({ ...formData, ngaji: e.target.value })}
            placeholder="Ngaji"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-tags"></i>
          </span>
          <input
            type="text"
            name="kemampuan"
            value={formData.kemampuan}
            onChange={(e) => setFormData({ ...formData, kemampuan: e.target.value })}
            placeholder="Kemampuan (pisahkan dengan koma)"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-book"></i>
          </span>
          <input
            type="text"
            name="pendidikan"
            value={formData.pendidikan}
            onChange={(e) => setFormData({ ...formData, pendidikan: e.target.value })}
            placeholder="Pendidikan"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-book-open"></i>
          </span>
          <input
            type="text"
            name="pengalaman"
            value={formData.pengalaman}
            onChange={(e) => setFormData({ ...formData, pengalaman: e.target.value })}
            placeholder="Pengalaman"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
        </div>

        {/* Ketersediaan */}
        <div>
          <button
            type="button"
            onClick={addKetersediaanField}
            className="mb-4 bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
          >
            Tambah Ketersediaan Waktu Mengajar
          </button>
          {formData.ketersediaan.map((item, index) => (
            <div key={index} className="mb-4 flex items-center space-x-2">
              <input
                type="text"
                name="hari"
                value={item.hari}
                onChange={(e) => handleKetersediaanChange(e, index)}
                placeholder="Hari"
                className="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              />
              <input
                type="text"
                name="waktu_mulai"
                value={item.waktu_mulai}
                onChange={(e) => handleKetersediaanChange(e, index)}
                placeholder="Waktu Mulai"
                className="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              />
              <input
                type="text"
                name="waktu_selesai"
                value={item.waktu_selesai}
                onChange={(e) => handleKetersediaanChange(e, index)}
                placeholder="Waktu Selesai"
                className="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              />
              <button
                type="button"
                onClick={() => removeKetersediaanField(index)}
                className="bg-red-500 text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
              >
                Hapus
              </button>
            </div>
          ))}
        </div>

        <div>
        <button
          type="submit"
          className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
          onClick={handleClickCreate}
        >
          Create Tentor
        </button>
          <a href="/admin/tentor">
            <button
              type="button"
              className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            >
              Cancel
            </button>
          </a>
        </div>
      </form>
    </div>
  );
}

CreateTentorForm.propTypes = {
  onSubmit: PropTypes.func,
};
